import { instance } from 'libs';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import * as Types from 'types';

export const image = (data: Types.GetImageRequest): AxiosPromise<Types.GetImageResponse> => {
  const request: AxiosRequestConfig = {
    url: '/image',
    method: 'GET',
    data,
  };
  return instance(request);
};
